import stringify from 'json-stringify-safe';
import { getLoggerInstance } from './logger';

const logger = getLoggerInstance();

export const defaultHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': true,
};

/**
 * Takes an error object and another object to create a serverless response
 * @returns {object}
 */
export const errorResponse = (error: any, extraObj: { [key: string]: any } = {}) => {
  const statusCode = error.statusCode || 500;
  const { request, response: axiosResponse, ...errorWithoutReqRes } = error;
  const response = {
    statusCode,
    headers: defaultHeaders,
    body: stringify({
      message: error.message,
      ...errorWithoutReqRes,
      ...extraObj,
      // report, this is skipped from response
      // because it's an internal flag to identify if an error should be sent to Sentry or not
      report: undefined,
    }),
  };
  logger.info({ response }, 'response');
  return response;
};

/**
 * Takes a body object and statusCode (optional) to create s serverless response
 * @returns {object}
 */
export const successResponse = (body = {}, statusCode = 200) => {
  const response = {
    statusCode,
    headers: defaultHeaders,
    body: stringify(body),
  };
  logger.info({ response }, 'response');
  return response;
};
